module.exports = "/../../dist/frontend/images/user-pin.png?ef4846742a5879b85d7d4ec6b8069c50";